import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/gluestack/card';
import { MessageView } from '@/components/ui/MessageView';
import { ImagePattern } from '@/components/ui/ImagePattern';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { StartUp02Icon } from '@hugeicons-pro/core-solid-rounded';
import { usePaywallError } from '@/hooks/usePaywallError';
import { useCommunity } from '@/hooks/useCommunity';
import { useTheme } from '@/components/providers/ThemeProvider';
import { getPattern } from '@/constants/patterns';

export type PremiumUpgradeListType = 'photos' | 'members' | 'conversation';

interface IPremiumUpgradeCardProps {
  listType: PremiumUpgradeListType;
}

export function PremiumUpgradeCard({ listType }: IPremiumUpgradeCardProps) {
  const { t } = useTranslation();
  const { navigateToPlans } = usePaywallError();
  const community = useCommunity();
  const { effectiveColorScheme } = useTheme();

  const premiumPlan = community?.premiumPlan ?? 'Premium';
  const pattern = getPattern(community?.defaultPattern ?? 'none');
  const patternOpacity = effectiveColorScheme === 'dark' ? 0.15 : 0.5;

  return (
    <Card size="lg" className="overflow-hidden bg-background-200 dark:bg-background-100">
      {pattern.source && (
        <ImagePattern
          source={pattern.source}
          scale={pattern.scale * 1.5}
          opacity={patternOpacity}
        />
      )}
      <MessageView
        type="info"
        text={t(`premium.upgradeCard.${listType}`, { premiumPlan })}
        textClassName="text-typography-900"
        disableHeight
      >
        <ButtonWrapper
          icon={StartUp02Icon}
          action="primary"
          onPress={navigateToPlans}
          text={t('upgrade.upgrade_button')}
          className="mt-2"
        />
      </MessageView>
    </Card>
  );
}

